type MutableLock = { current: boolean };

export const applyOrderStagePeriodToRows = <
  T extends { _id: unknown; orderStagePeriod?: string },
>(rows: T[], orderIds: string[], orderStagePeriod: string): T[] => {
  const updatedOrderIds = new Set(orderIds);

  return rows.map((row) =>
    updatedOrderIds.has(String(row._id))
      ? { ...row, orderStagePeriod }
      : row,
  );
};

export const getEditingPeriodAfterBulkUpdate = <T>(
  editingOrderId: string | null,
  updatedOrderIds: string[],
  currentValue: T,
  updatedValue: T,
): T =>
  editingOrderId && updatedOrderIds.includes(editingOrderId)
    ? updatedValue
    : currentValue;

export const tryAcquireTripClosingUpdateLock = (lock: MutableLock): boolean => {
  if (lock.current) return false;
  lock.current = true;
  return true;
};

export const releaseTripClosingUpdateLock = (lock: MutableLock): void => {
  lock.current = false;
};
